import React from "react";
import TableRowExtrasButton from "../../app/modules/ECommerce/pages/folders/folder-buttons/TableRowExtrasButton";

function SelectionCheckbox({ isSelected, onChange }) {
  return (
    <>
      <input type="checkbox" style={{ display: "none" }} />
      <label className="checkbox checkbox-single">
        <input type="checkbox" checked={isSelected} onChange={onChange} />
        <span />
      </label>
    </>
  );
}

function groupingItemOnSelect(props) {
  const { ids, setIds, postId } = props;

  if (ids.some((id) => id === postId)) {
    setIds(ids.filter((id) => id !== postId));
  } else {
    const newIds = [...ids];
    newIds.push(postId);
    setIds(newIds);
  }
}

function groupingAllOnSelect(props, selected) {
  const { isSelected, setIds, posts } = props;
  const allIds = [];

  // select all if not every is selected
  if (selected && selected === "Sve") {
    posts.forEach((el) => allIds.push(el.id));
    setIds(allIds);
    return isSelected;
  }
  if (selected && selected === "Nijedna") {
    setIds([]);
    return isSelected;
  }

  if (selected && selected === "Štampane") {
    posts.forEach((el) => {
      if (el.type == "stampani") {
        allIds.push(el.id);
      }
    });
    setIds(allIds);
    return isSelected;
  }

  if (selected && selected === "Internet") {
    posts.forEach((el) => {
      if (el.type == "internet") {
        allIds.push(el.id);
      }
    });
    setIds(allIds);
    return isSelected;
  }

  if (selected && selected === "Elektronske") {
    posts.forEach((el) => {
      if (el.type == "elektronski") {
        allIds.push(el.id);
      }
    });
    setIds(allIds);
    return isSelected;
  }

  if (!isSelected) {
    posts.forEach((el) => allIds.push(el.id));
    setIds(allIds);
    return isSelected;
  } else {
    setIds([]);
    return isSelected;
  }
}

// check official documentations: https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html?selectedKind=Row%20Selection&selectedStory=Custom%20Selection%20Column%20Header%20Style&full=0&addons=1&stories=1&panelRight=0&addonPanel=storybook%2Factions%2Factions-panel
export function getSelectRow(props) {
  const { posts, ids, setIds } = props;
  return {
    mode: "checkbox",
    clickToSelect: true,
    hideSelectAll: false,
    selectionHeaderRenderer: () => {
      const isSelected = posts && ids.length > 0 && posts.length === ids.length;
      const props = { isSelected, posts, setIds };
      return (
        <div className="d-flex">
          <SelectionCheckbox
            isSelected={isSelected}
            onChange={() => groupingAllOnSelect(props)}
          />
          <TableRowExtrasButton
            onClickHandler={(selected) => groupingAllOnSelect(props, selected)}
          />
        </div>
      );
    },
    selectionRenderer: ({ rowIndex }) => {
      const isSelected = ids.some((el) => el === posts[rowIndex]?.id);
      const props = { ids, setIds, postId: posts[rowIndex]?.id };
      return (
        <SelectionCheckbox
          isSelected={isSelected}
          onChange={() => groupingItemOnSelect(props)}
        />
      );
    },
  };
}
